class {
  onCreate() {
    this.state = {
      expandedItems: {},
      faq : [
      {
        question: "Who should use Plixi?",
        answer: "Plixi is for anyone who wants to grow their Instagram account organically. Whether you're a business, influencer, or just someone who wants to grow their personal account, Plixi is the best Instagram growth service for you."
      },
      {
        question: "What is required to use Plixi?",
        answer: "All you need is an Instagram account. You can use Plixi on your personal account, business account, or even an influencer account. You can also use Plixi on multiple accounts at once."
      },
      {
        question: "How many followers can I get with Plixi?",
        answer: "At least 1000 followers per month. Plixi is designed to help you grow your account organically. We don't use bots or fake accounts to grow your account. Instead, we use a combination of organic growth strategies to help you grow your account naturally."
      }
    ]
    };
  }

  toggleItem(itemId) {
    this.state.expandedItems = {
      ...this.state.expandedItems,
      [itemId]: !this.state.expandedItems[itemId]
    };
  }
}

<div class="faq-accordion section flex justify-center py-0 mt-64 mb-12 md-max:mt-64">
  <div class="faq-container faq">
    <h2 class="faq-title xl bold before-enter enter text-center" style="line-height: unset;">Frequently Asked Questions</h2>
    
    <div class="faq-items before-enter enter">
      <for|item, index| of=state.faq>
        <div class="faq-item">
          <div 
            class=["faq-question", state.expandedItems[`item-${index}`] && "active"]
            onClick("toggleItem", `item-${index}`)
          >
            <span>
              <i class="fa fa-solid fa-chevron-down"></i>
              ${item.question}
            </span>
          </div>
          <div class=["faq-answer", state.expandedItems[`item-${index}`] && "expanded"]>
            <p>${item.answer}</p>
          </div>
        </div>
      </for>
    </div>

    <div itemscope="itemscope" itemtype="https://schema.org/FAQPage" class="hide-faq">
      <for|item, index| of=state.faq>
        <div itemscope="itemscope" itemprop="mainEntity" itemtype="https://schema.org/Question">
          <h3 itemprop="name">${item.question}</h3>
          <div itemscope="itemscope" itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <div itemprop="text">
              ${item.answer}
            </div>
          </div>
        </div>
      </for>
    </div>
  </div>
</div>

<!-- FAQ Styling -->
<style>
    .hide-faq {
      display: none;
    }
    .faq-accordion {
      border-top: 1px solid #E7EBEF;
      max-width: 800px;
      margin: 0 auto;
    }
    .faq {
      padding-top: 50px;
    }
    .faq-title {
      margin-bottom: 2rem;
      text-align: center;
    }
    .faq-items {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
    .faq-item {
      border-bottom: 1px solid #0E151B;
    }
    .faq h2, .faq-content-left {
      text-align: left;
    }
    .faq-container.faq h2.enter {
      font-family: CeraPro,sans-serif;
      line-height: 90px;
      font-size: 20px;
      font-weight: 700;
    }           
    .faq-content-first {
      color: #858d96;
      padding-top: 50px;
    }           
    .faq-content-second {
      font-size: 24px;
      margin-top: 5px;
    }           
    .faq-content-svg {
      display: flex;
    }           
    .faq-question i.fas.fa-chevron-down {
      vertical-align: middle;
      margin-right: 15px;
      transition: transform 0.3s ease;
    }
    .faq-question i.fas.fa-chevron-down.rotated {
      transform: rotate(180deg);
    }
    .faq-body-search {
      align-items: center;
      display: flex;
      margin-bottom: 2px;
      position: relative;
    }           
    .faq-body-more {
      align-items: center;
      color: #858d96;
      cursor: pointer;
      display: flex;
      font-size: 18px;
      margin-top: 20px;
      padding: 20px 0;
    }           
    @media (max-width: 991px) {
      .faq {
        flex-direction: column;
      }           
      .faq-content {
        column-gap: 40px;
        display: grid;
        grid-template-columns: 1fr;
      }           
      .faq-content-svg {
        justify-content: center;
      }           
      .faq-content-left {
        text-align: center;
      }
      .faq-container.faq h2.enter {
        line-height: 55px;
        font-size: 16px;
      }           
      .faq-spacer {
        display: none;
      }
    }           
    .faq-container {
      margin-left: auto;
      margin-right: auto;
      padding-left: 15px;
      padding-right: 15px;
    }    
    @media (max-width: 500px) {
      .faq-container {
        margin-left: 0;
        padding-left: 0;
        padding-right:0;
        margin-right:0;
      }
    }       
    @media (min-width: 768px) {
      .faq-container {
        width: 750px;
      }
    .faq-accordion{
      border-top: 0px;
    }
    .faq{
      padding-top: 0px;
    }
    .faq-question>span{
      font-size:14px;
    }

    }           
    @media (min-width: 992px) {
      .faq-container {
        width: 970px;
      }
    }           
    @media (min-width: 1200px) {
      .faq-container {
        width: 1170px;
      }
    }           
    .before-enter {
      /* transition: all 1.5s; */
    }           
    .enter {
      opacity: 1;
      transform: translateY(0);
    }           
    .faq h2 {
      max-width: 700px;
    }           
    .faq-content-svg a {
      cursor: pointer;
    }           
    .faq-content-svg-arrow svg {
      font-size: 90px;
      transform: rotate(250deg);
    }           
    .faq-body-search svg {
      font-size: 28px;
      position: absolute;
    }           
    .faq-body-search input {
      appearance: none;
      background-color: transparent;
      border-bottom: 1px dashed #858d96;
      border-radius: 0;
      border-style: dashed;
      font-size: 18px;
      font-weight: 300;
      padding: 20px 65px 20px 44px;
      width: 50%;
    }           
    .faq-body-more svg {
      font-size: 24px;
      margin-left: 10px;
    }           
    .faq-body ul {
      width: 100%;
      justify-content: left;
      line-height: 27px;
      text-align: left;
      margin-top: 15px;
    }           
    @media (max-width: 991px) {
      .faq h2 {
        text-align: center;
      }           
      .faq-body input {
        font-size: 20px;
        padding: 20px 20px 20px 44px;
        width: 100%;
      }
    }           
    .faq-content-svg a svg {
      margin-top: 30px;
    }           
    .faq-body ul li {
      border-bottom: 1px solid #0E151B;
      cursor: pointer;
      position: relative;
      z-index: 0;
    }           
    .faq-body-more:hover {
      color: #000;
    }           
    .faq-body-search input:focus {
      border-bottom: 1px solid #000;
      outline: 0;
    }           
    .faq-question {
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      padding: 13px 0;
      font-size: 16px;
      font-weight: 500;
      font-family: Cera Pro,sans-serif;
      color: #0E151B;
    }
    .faq-question.active {
      color: #0E151B;
    }
    .faq-question i.fa-chevron-down {
      vertical-align: middle;
      margin-right: 15px;
      transition: transform 0.3s ease;
    }
    .faq-question.active i.fa-chevron-down {
      transform: rotate(180deg);
    }
    .faq-answer {
      height: 0;
      pointer-events: none;
      opacity: 0;
      padding: 0 30px;
      overflow: hidden;
      transition: all 0.3s ease;
    }
    .faq-answer.expanded {
      height: auto;
      opacity: 1;
      padding: 0 0 30px;
      pointer-events: all;
    }
    .faq-answer p {
      line-height: 1.5;
      font-size: 16px;
      color: #86939E
    }           
    .faq-body ul .faq-answer b {
      font-weight: 600;
    }           
    .faq-body ul .faq-answer a {
      color: #3279f7;
      font-weight: 500;
    }           
    .faq-body ul .faq-question label svg {
      display: inline-block;
      color: #0E151B;
      font-size: 14px;
      margin-right: 20px;
    }
    .faq-question>span{
      font-size:16px;
    }
    .faq-body ul .faq-answer a:hover {
      text-decoration: underline;
    }
    .contact_footer + div{
      /* display:none; */
    }
  </style>